import { Feature, IActionPointInfo } from '@tencent/workbench';
import { config } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import { IThemeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { IChangeTemplateService } from '@src/slide/application/service/change-template-service/index.interface';
import { IReactionDisposer } from 'mobx/lib/internal';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';

@Feature()
export class ChangeTemplateMoreFeature extends BaseSelectablePanelFeature {
    id = config.id;
    config = config;
    currentThemeModel?: IThemeModel;
    width = 280;
    colNumber = 4;
    public initReaction: IReactionDisposer;
    public changeTemplateServiceInstance: IChangeTemplateService;
    public constructor() {
        super();
    }

    public onClick = (info: IActionPointInfo) => {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.BEAUTIFY_TAB,
            action: TDWActionType.BEAUTIFY_MORE_TEMPLATE,
        });
        this.getAppService().editableServiceLayer?.changeTemplateService?.promise().then((module) => {
            module.updateAid(this.getAidOptions(info));
            module.showTemplateBeautifyDialog(undefined);
        });
    };

    private getAidOptions(info: IActionPointInfo) {
        if (info.path[0] === FIXED_KEYS_DOUBLE.TOOLBAR_VIP) {
            return {
                position: 'toolbarviptab',
                feature: 'template',
                apprec1: 'slide',
            };
        }
        return {
            position: 'toolbar',
            feature: 'template',
            apprec1: 'slide',
        };
    }
}
